import UnderMaintenance from '../components/UnderMaintenance';

export default function Blog() {
  return <UnderMaintenance pageTitle="Blog" />;
}
